import { Group } from '@mantine/core';
import { OpenComponent } from '../../../enums/misc.enum';
import { formatDate3LetterMonth } from '../../../helpers/date-convert';
import { BasicPOSs } from '../../../type/pos.types';
import StatusText from '../../admin-table/components/status-text.component';
import XSkeletonLoadingTableBody from '../../x-components/x-skeletons/x-skeleton-loading-table.component';
import XSafeTextInfo from '../../x-components/x-safe-text-info.component';
import XThead from '../../x-components/x-table-header.component';
import XTable from '../../x-components/x-table/x-table.component';
import { ChangeEvent } from 'react';

function POSsTable(props: Props) {
  const {
    pos,
    setComponentManager,
    isLoading,
    setSelectedPOSId,
    checkedAll,
    setCheckedAll,
    isChecked,
    setIsChecked,
    isViewOnly,
  } = props;

  const handleRowClick = (posId: number) => {
    setComponentManager(OpenComponent.VIEW_USER);
    setSelectedPOSId(posId);
  };

  const handleCheck = (e: ChangeEvent<HTMLInputElement>) => {
    const { id, checked } = e.target;

    if (checked) {
      setIsChecked([...isChecked, Number(id)]);
    } else {
      setIsChecked(isChecked.filter((item) => item !== Number(id)));
    }
  };

  const handleCheckAll = () => {
    if (!pos) {
      return;
    }
    let arr = pos;
    setCheckedAll(!checkedAll);

    if (checkedAll) {
      setIsChecked([]);
    } else {
      setIsChecked(arr.map((li) => li.posId));
    }
  };

  return (
    <XTable>
      <XThead>
        <tr>
          {!isViewOnly && (
            <th style={{ width: 30 }}>
              <input
                type='checkbox'
                style={{ cursor: 'pointer' }}
                onChange={handleCheckAll}
                checked={checkedAll}
              />
            </th>
          )}
          <th>POS name</th>
          <th>Activation Code</th>
          <th>Association</th>
          <th>Status</th>
          <th>Date Activated</th>
          <th>POS Status</th>
        </tr>
      </XThead>
      {isLoading ? (
        <XSkeletonLoadingTableBody numColumns={7} />
      ) : (
        <tbody>
          {pos?.map((pos) => (
            <tr key={pos.posId}>
              {!isViewOnly && (
                <td>
                  <input
                    type='checkbox'
                    style={{ cursor: 'pointer' }}
                    id={pos.posId.toString()}
                    checked={isChecked.includes(pos.posId)}
                    onChange={handleCheck}
                  />
                </td>
              )}

              <td onClick={() => handleRowClick(pos.posId)}>
                <XSafeTextInfo data={pos.posName} />
              </td>
              <td onClick={() => handleRowClick(pos.posId)}>
                <XSafeTextInfo data={pos.activationCode.code} />
              </td>
              <td onClick={() => handleRowClick(pos.posId)}>
                <Group>
                  <XSafeTextInfo data='Reseller:' />
                  <XSafeTextInfo
                    data={pos.association.resellerName}
                    weight={600}
                  />
                </Group>
                <Group>
                  <XSafeTextInfo data='Merchant:' />
                  <XSafeTextInfo
                    data={pos.association.merchantName}
                    weight={600}
                  />
                </Group>
                <Group>
                  <XSafeTextInfo data='Branch:' />
                  <XSafeTextInfo
                    data={pos.association.branchName}
                    weight={600}
                  />
                </Group>
              </td>
              <td onClick={() => handleRowClick(pos.posId)}>
                <StatusText
                  status={
                    pos.activationCode.activationStatus
                      ? 'ACTIVATED'
                      : 'NOT_ACTIVATED'
                  }
                />
              </td>
              <td onClick={() => handleRowClick(pos.posId)}>
                <XSafeTextInfo
                  data={formatDate3LetterMonth(
                    pos.activationCode.dateActivated?.toString()
                  )}
                />
              </td>
              <td onClick={() => handleRowClick(pos.posId)}>
                <StatusText status={pos.isActive ? 'ENABLED' : 'DISABLED'} />
              </td>
            </tr>
          ))}
        </tbody>
      )}
    </XTable>
  );
}

export default POSsTable;

interface Props {
  pos: BasicPOSs[] | undefined;
  isLoading: boolean;
  setComponentManager: React.Dispatch<React.SetStateAction<OpenComponent>>;
  setSelectedPOSId: React.Dispatch<React.SetStateAction<number | undefined>>;
  checkedAll: boolean;
  setCheckedAll: React.Dispatch<React.SetStateAction<boolean>>;
  isChecked: number[];
  setIsChecked: React.Dispatch<React.SetStateAction<number[]>>;
  isViewOnly: boolean;
}
